import { observable } from "mobx";
import type { Combination } from "./faultyCombination";

class PermissionAreaWithFaultyCombinationsResponse {
  @observable
  id!: string;

  @observable
  name!: string;

  @observable
  faultyCombinations: Combination[] = [];
}

export default PermissionAreaWithFaultyCombinationsResponse;
